import { Button } from "primereact/button";
import type { Menu } from "primereact/menu";
import { Menubar } from "primereact/menubar";
import type { MenuItem } from "primereact/menuitem";
import { SelectButton } from "primereact/selectbutton";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { assetService } from "src/core/services/assetService";
import { useAuthStore } from "../../../../../features/auth/services/useAuthStore";
import { useSettingsStore } from "../../../../../features/settings/services/useSettingsStore";
import { LoggedInMenu } from "../LoggedInMenu/LoggedInMenu";
import "./MainMenu.css";

export function MainMenu() {
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  const settingsStore = useSettingsStore();
  const authStore = useAuthStore();

  const mainMenuItems: MenuItem[] = [];

  const loggedInMenuRef = useRef<Menu>(null);
  const loggedInMenuButtonRef = useRef<Button>(null);

  const langOptions = ["HU", "EN"];

  return (
    <div className="mainMenu">
      <Menubar
        model={mainMenuItems}
        start={
          <div className="flex justify-content-start align-items-center gap-2">
            <img
              src={assetService.getImagePath("header_logo_left.png")}
              title={settingsStore.legacySettings.providerName}
              className="logo cursor-pointer"
              onClick={() => {
                navigate(authStore.user?.isLoggedIn ? "/home" : "/");
              }}
            />
          </div>
        }
        end={
          <div className="flex justify-content-end align-items-center gap-1">
            <div className="flex align-items-center gap-3">
              {authStore.user?.isLoggedIn && (
                <Button
                  ref={loggedInMenuButtonRef}
                  className="text-2xl"
                  onClick={(event) => {
                    loggedInMenuRef.current?.toggle(event);
                  }}
                >
                  <i
                    className="pi pi-user"
                    style={{ fontSize: "2rem" }}
                  ></i>
                </Button>
              )}

              <SelectButton
                value={i18n.language.toUpperCase()}
                onChange={(e) => {
                  if (e.value !== i18n.language.toUpperCase())
                    i18n.changeLanguage((e.value as string)?.toLowerCase());
                }}
                options={langOptions}
              />
            </div>
          </div>
        }
        className={
          "sm:pl-1 sm:pr-1 md:pl-2 md:pr-2 lg:pl-5 lg:pr-5 " +
          (authStore.user.isLoggedIn ? "login" : "logout")
        }
      />

      <LoggedInMenu
        loggedInMenuRef={loggedInMenuRef}
        loggedInMenuButtonRef={loggedInMenuButtonRef}
      />
    </div>
  );
}
